angular.module('sfx.api.v2').service('emailTemplateV2Service', [
    '$http',
    '$log',
    'API_URL',
    function ($http, $log, API_URL) {
        const resourceEndpoint = API_URL + '/v2/alert/emailtemplate';
        const FETCH_LIMIT = 500;

        function getResults(data) {
            return Array.isArray(data) ? data : data.results || [];
        }

        function addEmailTemplateSummaries(results, emailTemplates, seenTemplateIds) {
            let newTemplateCount = 0;

            results.forEach(function (emailTemplate) {
                if (seenTemplateIds[emailTemplate.id]) {
                    return;
                }

                seenTemplateIds[emailTemplate.id] = true;
                newTemplateCount++;

                emailTemplates.push({
                    id: emailTemplate.id,
                    name: emailTemplate.name,
                });
            });

            return newTemplateCount;
        }

        function hasMorePages(data, results, offset, newTemplateCount) {
            if (!results.length) {
                return false;
            }

            if (Array.isArray(data)) {
                return results.length === FETCH_LIMIT && newTemplateCount > 0;
            }

            if (typeof data.count === 'number') {
                return offset + results.length < data.count;
            }

            return results.length === FETCH_LIMIT;
        }

        function fetchPage(offset, emailTemplates, seenTemplateIds) {
            return $http
                .get(resourceEndpoint, {
                    params: {
                        limit: FETCH_LIMIT,
                        offset: offset,
                        orderBy: 'name',
                    },
                })
                .then(function (response) {
                    const data = response.data || {};
                    const results = getResults(data);
                    const newTemplateCount = addEmailTemplateSummaries(
                        results,
                        emailTemplates,
                        seenTemplateIds
                    );

                    if (!hasMorePages(data, results, offset, newTemplateCount)) {
                        return emailTemplates;
                    }

                    return fetchPage(offset + FETCH_LIMIT, emailTemplates, seenTemplateIds);
                });
        }

        function getAll() {
            return fetchPage(0, [], Object.create(null)).catch(function (error) {
                $log.error('Unable to fetch email templates', error);
                return [];
            });
        }

        return {
            getAll: getAll,
        };
    },
]);
